<mat-progress-bar class="fs-mb-2" mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
<div class="users-container">
  <sn-empty-state
    *ngIf="users.length < 1"
    icon="cancel_presentation"
    [title]="emptyStateTitle"
  >
    <button mat-button *ngIf="canChange" (click)="addUsers()">{{ 'users.policyGroups.manageFormActionsAddUsers' | t }}</button>
  </sn-empty-state>
  <ng-container *ngIf="users.length > 0">
    <mat-card class="user-item" *ngFor="let user of users; let i = index">
      <div class="info name">{{ user.firstName }} {{ user.lastName }}</div>
      <div class="info email">
        {{ user.email }}
      </div>
      <sn-icon-button *ngIf="canChange" color="danger" class="remove-button" (click)="removeUser(i)"
        ><sn-icon fontSet="fal" fontIcon="fa-xmark"></sn-icon
      ></sn-icon-button>
    </mat-card>
  </ng-container>
</div>
<div class="fs-actions" *ngIf="canChange">
  <button mat-button class="add-user" (click)="addUsers()">
    <sn-icon fontSet="fal" fontIcon="fa-plus"></sn-icon> {{ 'users.policyGroups.manageFormActionsAddUsers' | t }}
  </button>
  <button mat-button class="save-users" color="success" (click)="save()">
    <sn-icon fontSet="fal" fontIcon="fa-save"></sn-icon> {{ 'users.policyGroups.manageFormActionsSaveUsers' | t }}
  </button>
</div>
